import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { selfCertificationDocumentTypesArray } from "./constants";

export type Props = {
  readonly: boolean;
  documentName?: string;
};

const SelfCertificationFormValues = ({ readonly, documentName = "" }: Props) => {
  return (
    <SubTypeDocumentSelector
      readonly={readonly}
      subTypeDocuments={selfCertificationDocumentTypesArray}
      placeholder="Select a self-certification document type"
      name="secondaryDocumentType"
      label="Document sub-type"
      documentName={documentName}
    />
  );
};

export default SelfCertificationFormValues;
